// extracted by mini-css-extract-plugin
export default {"selectObject":"SelectObject_selectObject__McxJK","opportunitiesTheme":"SelectObject_opportunitiesTheme__Sn5jj"};